import { GeoPoint } from '@core/const';
import { DeliverySlot } from '@delivery/const';
import { StateUtils } from '@spartacus/core';
import { DELIVERY_SLOTS } from '../delivery-state';

export const LOAD_DELIVERY_SLOTS = '[Delivery] Load Delivery Slots';
export const LOAD_DELIVERY_SLOTS_FAIL = '[Delivery] Load Delivery Slots Fail';
export const LOAD_DELIVERY_SLOTS_SUCCESS = '[Delivery] Load Delivery Slots Success';
export const LOAD_DELIVERY_SLOTS_RESET = '[Delivery] Delivery Slots Reset';

export class LoadDeliverySlots extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_DELIVERY_SLOTS;

  constructor(public payload: { geoPoint: GeoPoint; weight: number }) {
    super(DELIVERY_SLOTS);
  }
}

export class LoadDeliverySlotsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_DELIVERY_SLOTS_FAIL;

  constructor(public payload: any) {
    super(DELIVERY_SLOTS, payload);
  }
}

export class LoadDeliverySlotsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_DELIVERY_SLOTS_SUCCESS;

  constructor(public payload: DeliverySlot[]) {
    super(DELIVERY_SLOTS);
  }
}

export class LoadDeliverySlotsReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_DELIVERY_SLOTS_RESET;

  constructor() {
    super(DELIVERY_SLOTS);
  }
}

export type DeliverySlotsActions =
  | LoadDeliverySlots
  | LoadDeliverySlotsSuccess
  | LoadDeliverySlotsFail
  | LoadDeliverySlotsReset;
